import request from '@/utils/request'

let homePageApi = {
  /*分类*/
  category(data, errorback) {
    return request._get('/product/category/index', data, errorback);
  },
  /*分类*/
  categorys(data, errorback) {
    return request._get('/product/category/level/list', data, errorback);
  },
  /*轮播*/
  getBanner(data, errorback) {
    return request._get('/index/index', data, errorback);
  },
}
export default homePageApi;


// WEBPACK FOOTER //
// ./src/api/homePageApi.js